module.exports = __webpack_public_path__ + "media/images/brands/logo_franchienergia_grande-c84b656c59268ecea1f7dbc72db89794.svg";